import {
  Component,
  forwardRef,
  OnInit,
  inject,
  DestroyRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsConversationConfig } from '@ui/shared/model';

@Component({
  selector: 'app-conversation-general-config-form',
  templateUrl: './conversation-general-config-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConversationGeneralConfigFormComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, TranslatePipe]
})
export class ConversationGeneralConfigFormComponent
  implements OnInit, ControlValueAccessor
{
  #destroyRef = inject(DestroyRef);
  private fb = inject(FormBuilder);

  public form: FormGroup;
  public value: UserSettingsConversationConfig;

  private onChange = (value: unknown) => value;
  private onTouch = () => null;

  public ngOnInit(): void {
    this.form = this.fb.group({
      notifyWhenReceivingMessage: [false]
    });

    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((value: UserSettingsConversationConfig) => {
        this.value = value;
        this.onChange(this.value);
        this.onTouch();
      });
  }

  public registerOnChange(fn) {
    this.onChange = fn;
  }

  public registerOnTouched(fn) {
    this.onTouch = fn;
  }

  public writeValue(value: UserSettingsConversationConfig) {
    this.form.patchValue(value);
    this.value = value;
  }
}
